import styles from './AWSServiceLink.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const linkList = [
  {
    title: 'Amazon ECS',
    link: '/services/amazonecs/',
    imgSrc: '/img/common/aws_ecs.webp',
  },
  {
    title: 'AWS App Runnrer',
    link: '/services/awsapprunner/',
    imgSrc: '/img/common/aws_apprunner.webp',
  },
  {
    title: 'AWS CodePipeline',
    link: '/services/awscodepipeline/',
    imgSrc: '/img/common/aws_codepipeline.webp',
  },
  {
    title: 'AWS Fargate',
    link: '/services/awsfargate/',
    imgSrc: '/img/common/aws_fargate.webp',
  },
]

const AWSServiceLink: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.AWSLink} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>AWS運用支援</h2>
      <p className={styles.sectionRead}>クラウドネイティブに関連した、AWSの運用支援ページもご覧ください</p>
      <nav className={styles.AWSNav}>
        <ul className={styles.AWSNav__list}>
          {linkList.map((item, index) => (
            <li key={index} className={styles.AWSNav__list__item}>
              <a href={item.link} className={styles.AWSNav__list__item__link}>
                <figure className={styles.AWSNav__list__item__link__figure}>
                  <img
                    src={item.imgSrc}
                    alt={item.title}
                    width={40}
                    height={40}
                    className={styles.AWSNav__list__item__link__figure__image}
                  />
                </figure>
                <span className={styles.AWSNav__list__item__link__text}>{item.title}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  )
}

export default AWSServiceLink
